import "./App.css";
import IntroOdijn from "./pages/IntroOdijn";

function App() {
  return <IntroOdijn />;
}

export default App;
